<template>
  <div class="chat-options">
    <div class="header">
      <a class="link-icon-after link-add" v-on:click.prevent="invite = true">Add People To Chat</a>
    </div>
    <div v-if="$parent.members.length < 3">
      <single-member v-for="member in $parent.members" v-if="member['.key'] !== $root.user.uid" :member="member['.key']" :key="member['.key']"></single-member>
    </div>
    <div v-else class="group-chat-holder">
      <multiple-members v-for="member in $parent.members" v-if="member['.key'] !== $root.user.uid" :member="member['.key']" :key="member['.key']"></multiple-members>
    </div>
    <!-- <give-reputation v-for="member in $parent.members" v-if="$parent.members.length < 3 && member['.key'] !== $root.user.uid" :member="member['.key']" :key="member['.key']"></give-reputation> -->
    <div class="admin-options">
      <h5>Options</h5>
      <a href="#" class="link-simple" v-on:click.prevent="deleteChat">Delete Chat</a>
    </div>
    <invite v-if="invite" :chatID="chatID"></invite>
  </div>
</template>

<script>
import { db } from '@/firebase'
import Invite from './Invite'
import SingleMember from './SingleMember'
import MultipleMembers from './MultipleMembers'
import GiveReputation from './GiveReputation'

export default {
  name: 'Options',
  props: ['chatID'],
  data () {
    return {
      invite: false
    }
  },
  components: {
    Invite,
    SingleMember,
    MultipleMembers,
    GiveReputation
  },
  methods: {
    deleteChat () {
      db.ref('users-chats/' + this.$root.user.uid + '/' + this.chatID + '/showAfter').set(Date.now())
    }
  }
}
</script>



// WEBPACK FOOTER //
// Options.vue?dd34d19a